import Vue from 'vue'
import * as plugins from '@/plugins/plugins'

const Plugins = {
  install (Vue) {
    Vue.prototype.$plugins = plugins
  }
}

Vue.use(Plugins)
